import React, { useRef, useMemo, useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './index.scss';

const QuillEditor = ({
   text, onChange, modules, withoutBorder, placeholder, isLoading, handleChangeWords, words
}) => {
   const [isOpenFirstVideo, setIsOpenFirstVideo] = useState(false)
   const formats = useMemo(() => [
      'bold', 'italic', 'underline', 'strike', 'blockquote', 'code-block', 'direction',
      'header', 'font', 'size', 'list', 'bullet', 'indent', 'ordered', 'script', 'link',
      'image', 'color', 'background', 'align', 'clean', 'imageBlot', 'width', 'height',
      'style', 'data-align', 'placeholder', 'autocomplete',
   ], []);

   useEffect(() => {
      if (text) {
         const splitedText = text.split(' ');
         let wordCount = 0;

         const intervalId = setInterval(() => {
            handleChangeWords(splitedText, wordCount);
            wordCount++;

            if (wordCount === splitedText.length) {
               clearInterval(intervalId);
            }
         }, 30);
      }
   }, [text]);

   const editorRef = useRef(null);
   const isFirstRender = useRef(true);

   const handleOpenVideo = () => {
      setIsOpenFirstVideo(true)
   }

   const currentModules = useMemo(() => ({
      toolbar: {
         container: [
            [{ header: [1, 2, 3, 4, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'align': [] }],
            ['link', 'blockquote'],
            [{ 'watchVideo': 'Watch Video' }] 
         ],
         handlers: {
            watchVideo: () => handleOpenVideo()
         },
      },
      clipboard: { matchVisual: false },
   }), []);

   const handleChange = (value) => {
      if (isFirstRender.current) {
         isFirstRender.current = false;
         return;
      }
      onChange(value);
   };

   useEffect(() => {
      const buttonElement = document.querySelector('.ql-watchVideo');
      buttonElement.style.width = '100%';
      buttonElement.style.marginBottom = '5px';
      buttonElement.style.color = '#444444';
      buttonElement.style.fontWeight = 'bold';
      buttonElement.innerText = 'Watch Video';
   }, [])

   return (
         <div
            ref={ editorRef }
            className={classNames(
               'quillEditor',
               { 'quillEditor__withoutBorder': withoutBorder }
            )}
         >
            {isOpenFirstVideo && (
              <div className="videoPlayer">
                <div
                  className="closer"
                  role="presentation"
                  onClick={() => {
                    setIsOpenFirstVideo(false);
                  }}
                ></div>
                <iframe
                    width="90%"
                    height="90%"
                    src="https://player.vimeo.com/video/1025514060"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen={true}
                  ></iframe>
                {/* <div className="videoPlayer__video">
                  <video src={video} controls autoPlay></video>
                  <Icon name="Close" onClick={() => setIsOpenFirstVideo(false)} />
                </div> */}
              </div>
            )}
            <ReactQuill
               value={ words }
               onChange={ handleChange }
               theme='snow'
               modules={ modules || currentModules }
               formats={ formats }
               placeholder={ placeholder }
               readOnly={!words.length}
            />
         </div>
   );
};
 
QuillEditor.propTypes = {
   text: PropTypes.string,
   onChange: PropTypes.func,
   handleChangeWords: PropTypes.func,
   withoutBorder: PropTypes.bool,
   isLoading: PropTypes.bool,
   modules: PropTypes.object,
   placeholder: PropTypes.string,
   words: PropTypes.string,
};
 
export default QuillEditor;
